<template>
    <b-modal
        v-model="isComponentModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal
    >
        <template #default="props">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Вы действительно хотите присоединить этого пользователя к ЦПО?</p>
                    <button
                        type="button"
                        class="delete"
                        @click="props.close"/>
                </header>
                <section class="modal-card-body">
                    <application :application-id="applicationId" @processing="disabled = $event" ref="application" />
                </section>
                <footer class="modal-card-foot">
                    <b-button
                        label="Присоединить"
                        type="is-success"
                        @click="approveApplication()"
                        :disabled="disabled"
                    />
                    <b-button
                        label="Закрыть"
                        @click="props.close" />
                </footer>
            </div>
        </template>
    </b-modal>
</template>
<script>


import Application from '../show/Application'
export default {
    props: {
        applicationId: {
            default: null,
            required: true,
        },
    },
    components: {
        Application,
    },
    data() {
        return {
            disabled: false
        }
    },
    computed: {
        isComponentModalActive: {
            get() {
                return this.applicationId !== null
            },
            set(val) {
                if(!val) this.$emit('update:applicationId', null)
            }
        },
    },
    methods: {
        approveApplication() {
            this.$refs.application.approve().then(()=>{
                this.isComponentModalActive = false
                this.$buefy.toast.open({
                    duration: 4000,
                    message: `Заявка одобрена`,
                    type: 'is-success',
                    hasIcon: true,
                    position: 'is-bottom'
                })
            })
        }
    }
}
</script>